export function isExternalUrl(url: string, hostname: string) {
  return (
    /^http(s)?:\/\//i.test(url) &&
    !url
      .replace(/^(?:http(s)?:\/\/)?(?:www\.)?/i, '')
      .split('/')[0]
      .match(hostname.replace(/^(?:www\.)?/i, ''))
  );
}
